document.addEventListener("DOMContentLoaded", () => {
  // --- Get product data from JSON script tag ---
  const productJsonEl = document.querySelector("[data-product-json]");
  if (!productJsonEl) return;
  const productData = JSON.parse(productJsonEl.textContent);

  // Helpers that sanitize and set image URLs
  const withProtocol = (src) => (src?.startsWith("//") ? "https:" + src : src || "");
  const setWidthParam = (src, width) => {
    if (!src) return "";
    const url = new URL(withProtocol(src));
    url.searchParams.set("width", String(width));
    return url.toString();
  };

  // Get variant by ID
  const getVariantById = (id) =>
    productData.variants.find(v => v.id == id) || productData.variants.find(v => v.id === Number(id));

  // Update SKU
  const updateSKU = (variant) => {
    const skuEl = document.querySelector(
      ".product-buybox .product__ratings-container .product__ratings span.uppercase [data-product-sku]"
    );
    if (!skuEl) return;
    skuEl.textContent = variant?.sku || "";
    skuEl.dataset.productSku = variant?.sku || "";
  };

  //  Update featured image
  const updateFeatured = (variant) => {
    const imgSrc = variant?.featured_image?.src;
    if (!imgSrc) return;
    const featuredSrc = setWidthParam(imgSrc, 1000);
    const thumbSrc = setWidthParam(imgSrc, 200);
    const alt = variant.featured_image.alt || variant.title || "";

    const featuredImg = document.querySelector("[data-featured-media-container] img.featured-media");
    const featuredAnchor = document.querySelector("[data-featured-media-container] a[data-fslightbox='pdp-gallery']");

    if (featuredImg) {
      featuredImg.src = featuredSrc;
      featuredImg.srcset = `${featuredSrc} 1x`;
      featuredImg.alt = alt;
    }
    if (featuredAnchor) {
      featuredAnchor.href = featuredSrc;
      featuredAnchor.setAttribute("data-thumb", thumbSrc);
    }
  };

  //  Update thumbnail image
  const updateActiveOrFirstThumb = (variant) => {
    const imgSrc = variant?.featured_image?.src;
    if (!imgSrc) return;
    const thumbSrc = setWidthParam(imgSrc, 200);
    const alt = variant.featured_image.alt || variant.title || "";

    const thumbsContainer = document.querySelector("[data-thumbs-container]");
    if (!thumbsContainer) return;

    const thumbWrap = thumbsContainer.querySelector(".thumb__container.active") ||
                      thumbsContainer.querySelector(".thumb__container");
    if (!thumbWrap) return;

    const thumbImg = thumbWrap.querySelector("img.thumb-media");
    if (thumbImg) {
      thumbImg.src = thumbSrc;
      thumbImg.srcset = `${thumbSrc} 1x`;
      thumbImg.alt = alt;
    }
  };

  //  Apply all updates (SKU, image, thumb, URL)
  const applyVariantUpdates = (variant) => {
    if (!variant) return;
    updateSKU(variant);
    updateFeatured(variant);
    updateActiveOrFirstThumb(variant);
  };

  // Shopify native variant event
  document.addEventListener("variant:changed", (event) => {
    const variant = event.detail?.variant;
    if (variant) {
      applyVariantUpdates(variant);
    }
  });

  // Fallback form listener
  const productForm = document.querySelector("form[data-product-form]");
  if (productForm) {
    productForm.addEventListener("change", () => {
      const id = productForm.querySelector('[name="id"]')?.value;
      const variant = getVariantById(id);
      if (variant) applyVariantUpdates(variant);
    });
  }

  // Swatch click handler
  document.querySelectorAll("[data-product-option-value][data-variant-id]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const id = btn.getAttribute("data-variant-id");
      const variant = getVariantById(id);
      if (variant) {
        applyVariantUpdates(variant);
      }
    });
  });

  // Initialize on page load
  const initialId = document.querySelector('[name="id"]')?.value;
  if (initialId) {
    const variant = getVariantById(initialId);
    if (variant) applyVariantUpdates(variant);
  }
});
